<template>
  <div class="about">
    <div class="banner outer">
      <div class="inside">
        <div class="companybox">易猎云（海南）科技有限公司</div>
        <p class="comtext">国内领先的RPO企业招聘数字化解决方案提供商</p>
      </div>
    </div>
    <div class="introduce outer">
      <div class="title_s">
        <div>
          <router-link to="/about"  active-class="actives">公司介绍</router-link>
          <router-link to="/media"  active-class="actives">媒体报道</router-link>
          <!-- <a :href="[`${path}/about${rou}`]">公司介绍</a>
          <a :href="[`${path}/media${rou}`]" class="actives">媒体报道</a> -->
        </div>
      </div>
      <div class="inside" style="height: max-content">
        <div class="introducetext">
          <h3>媒体报道</h3>
           <div class="meiti" @click="seven">
            <!-- <a :href="[`${URl}/media/1${rou}`]" target="_blank" style="display:none"></a> -->
            <a href="https://www.yilieyun.com/coverage/7" target="_blank"></a>
            <span>数字化提升的不仅是效率，更是人文体验</span>
            <p>
             数据已成为关键生产要素，加快建设数字中国也成为引领中国迈向经济强国的重要引擎。人力资本的数字化和资产化，将成为中国建设人才强国和人力资源强国，引领第四次产业革命不可或缺的力量。
            </p>
            <p>报道来自：客户世界机构</p>
            <br /><br />
            <p class="fenge" />
          </div>
          <div class="meiti" @click="one">
            <!-- <a :href="[`${URl}/media/1${rou}`]" target="_blank" style="display:none"></a> -->
            <a href="https://www.yilieyun.com/coverage/1" target="_blank"></a>
            <span>易猎云开启RPO3.0时代，人力管理平台是怎样进行数字化转型的？</span>
            <p>
              21世纪什么最重要，是人才!2004年，电影《天下无贼》中葛优的一句经典台词，在时隔近20年后的今天依旧十分贴切。但与以往不同的是，如今的人才招聘方式却出现了翻天覆地般的变化。
            </p>
            <p>报道来自：亿欧</p>
            <br /><br />
            <p class="fenge" />
          </div>
          <div class="meiti" @click="two">
            <!-- <a :href="[`${URl}/media/2${rou}`]" target="_blank"
              >36氪项目报道｜RPO数字化趋势下，「易猎云」想要为万亿主流市场造一个“工作系统”</a
            > -->
            <a href="https://www.yilieyun.com/coverage/2" target="_blank"></a>
            <span>36氪项目报道｜RPO数字化趋势下，「易猎云」想要为万亿主流市场造一个“工作系统”</span>
            <p>
              打通数据平台，支持私域获客，RPO员工效能方可被充分展现。
              据国家统计局数据，截止2020年底，中国人力资源市场规模达到21000亿元。
            </p>
            <p>报道来自：36氪</p>
            <br /><br />
            <p class="fenge" />
          </div>
          <div class="meiti" @click="three">
            <!-- <a :href="[`${URl}/media/3${rou}`]" target="_blank"
              >最有前景的RPO数字化趋势来到了，工作系统是怎么逆袭的？
            </a> -->
            <a href="https://www.yilieyun.com/coverage/3" target="_blank"></a>
            <span>最有前景的RPO数字化趋势来到了，工作系统是怎么逆袭的？</span>
            <p>
              打通数据平台、支持私域获客，RPO员工效能被充分展现，易猎云更像是一个工作系统，而非是传统意义上的流程管理软件。
            </p>
            <p>报道来自：极新Channel</p>
            <br /><br />
            <p class="fenge" />
          </div>
          <div class="meiti" @click="four">
            <!-- <a :href="[`${URl}/media/4${rou}`]" target="_blank"
              >批量招聘难题何解？他们发现了HRSaaS的新机会
            </a> -->
            <a href="https://www.yilieyun.com/coverage/4" target="_blank"></a>
            <span>批量招聘难题何解？他们发现了HRSaaS的新机会</span>
            <p>
              随着技术的发展和求职者求职渠道的多样化，RPO（招聘流程外包，Recruitment
              Process
              Outsourcing）机构信息化系统割裂的问题之上又叠加了多样化求职渠道高效管理的问题。
            </p>
            <p>报道来自：钛媒体</p>
            <br /><br />
            <p class="fenge" />
          </div>

          <!--          <div class="meiti" v-show="false">-->
          <!--            <a href="#" @click="five">产品打磨四年半，易猎云聚焦RPO行业数字化需求 | 新科技创</a>-->
          <!--            <p>2021年逐步开放给200多家客户2021年逐步开放给200多家客户，营收300万左右，希望满足没有自研能力的小微RPO团队的数字化需求，-->
          <!--              希望满足没有自研能力的小微RPO团队的数字化需求。，营收2021年逐步开放给200多家客户，营收2021年逐步开放给200多家客户，营收2021年逐步开放给200多家客户，营收</p>-->
          <!--            <p @click="five">报道来自：36Kr</p>-->
          <!--          </div>-->

          <div class="meiti" @click="oneless">
            <!-- <a :href="[`${URl}/media/5${rou}`]" target="_blank"
              >易猎云开创RPO数字化3.0时代 小微企业永久免费
            </a> -->
            <a href="https://www.yilieyun.com/coverage/5" target="_blank"></a>
            <span>易猎云开创RPO数字化3.0时代 小微企业永久免费</span>
            <p>
              近年来，中国作为快速发展的新兴人力资源服务市场，市场规模持续快速增长。根据中智咨询《2021中国人力资源服务供需调查报告》调研数据，“70.6%的中国人力资源服务机构开展人力资源招聘服务（RPO招聘流程外包）”
            </p>
            <p>报道来自：易猎云</p>
            <br /><br />
            <!-- <p class="fenge" /> -->
          </div>
        </div>
      </div>
    </div>
    <div style="height: 40px; background: #e7f2ff"></div>
    <div class="ontrial outer">
      <div class="inside">
        <h3>即刻开启数字化招聘人效提升之旅</h3>
        <p @click="trial">申请试用</p>
      </div>
    </div>
    <!--申请试用组件-->
    <populone :isshow="windowflag" :he="true" @handleChange="changewindow" />
  </div>
</template>
<script>
import populone from "@/components/views/popul/populone.vue";

export default {
  name: "about",
  data() {
    return {
      actives: 1,
      windowflag: false,
      URl: "",
      rou: "",
      path:'https://www.yilieyun.com'
    };
  },
  components: {
    populone,
  },
  metaInfo: {
    title: "易猎云媒体报道-更适合RPO的免费招聘管理系统",
    meta: [
      {
        name: "keywords",
        content: "易猎云，易猎云海南，易猎云招聘，招聘管理系统，RPO批量招聘",
      },
      {
        name: "description",
        content: "易猎云招聘管理系统，RPO公司批量招聘数字化首选的招聘系统",
      },
    ],
  },
  mounted() {
    this.URl = window.location.origin;
    if (window.location.href.split("?")[1])
      this.rou = `?${window.location.href.split("?")[1]}`;
    if (this.$route.params.identification) this.actives = 2;
  },
  methods: {
    lefts() {
      this.actives = 1;
    },
    rights() {
      this.actives = 2;
    },

    one() {
      window.open(`${this.URl}/coverage/1${this.rou}`);
    },
    two() {
      window.open(`${this.URl}/coverage/2${this.rou}`);
    },
    three() {
      window.open(`${this.URl}/coverage/3${this.rou}`);
    },
    four() {
      window.open(`${this.URl}/coverage/4${this.rou}`);
    },
    oneless() {
      window.open(`${this.URl}/coverage/5${this.rou}`);
    },
    five() {
      window.open(`${this.URl}/coverage/6${this.rou}`);
    },
    seven(){
      window.open(`${this.URl}/coverage/7${this.rou}`);
    },
    trial() {
      this.windowflag = true;
    },
    changewindow(value) {
      this.windowflag = value;
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";

.title_s {
  display: flex;
  justify-content: center;

  div {
    display: flex;
  }

  a {
    cursor: pointer;
    font-size: 36px;
    color: #1d2754;
    line-height: 80px;
    margin: 20px;
  }

  .actives {
    border-bottom: 3px solid #0084ff;
  }
}

.meiti {
  margin-bottom: 40px;

  a {
    display: block;
    font-size: 24px;
    margin: 0;
    color: #1d2754;
    font-weight: 800;
    line-height: 50px;
    cursor: pointer;
    margin-bottom: 15px;
  }

  a:hover {
    color: #1990ff;
  }
  span{
     display: block;
    font-size: 24px;
    margin: 0;
    color: #1d2754;
    font-weight: 800;
    line-height: 50px;
    cursor: pointer;
    margin-bottom: 15px;
  }
  span:hover{
    color: #1990ff;
  }

  p:nth-of-type(1) {
    font-size: 22px;
    font-weight: 500;
    color: #686d85;
    line-height: 30px;
    margin-left: 25px;
  }

  p:nth-of-type(2) {
    font-size: 22px;
    font-weight: 500;
    color: #686d85;
    line-height: 30px;
    float: right;
    cursor: pointer;
  }
  .fenge {
    height: 1px;
    background: #eeeeee;
  }
}

.about {
  margin-top: 85px;

  .banner {
    width: 100%;
    height: 504px;
    background-image: url("https://yilie.oss-cn-beijing.aliyuncs.com/front-yilieyun/official/lQLPJxZc3D83uM_NA_DNDwCwK9IfiCi3W6YCmTVsOoCdAA_3840_1008.png");
    background-repeat: no-repeat;
    background-size: 105%;
    padding-top: 133px;

    .companybox {
      width: 596px;
      height: 93px;
      background: #1990ff;
      margin-left: 26px;
      font-size: 36px;
      font-weight: 600;
      color: #ffffff;
      line-height: 93px;
      text-align: center;
    }

    .comtext {
      width: 790px;
      height: 165px;
      font-size: 34px;
      font-weight: 500;
      color: #1d2754;
      line-height: 55px;
      margin-left: 26px;
      margin-top: 34px;
    }
  }

  .introduce {
    width: 100%;
    height: 1510px;
    background: #e7f2ff;

    .introducetext {
      width: 100%;
      height: 1400px;
      background: #ffffff;
      border-radius: 10px;
      padding-top: 28px;
      padding-left: 53px;
      padding-right: 53px;

      hr {
        background: red;
      }

      h3 {
        font-size: 40px;
        color: #1d2754;
        line-height: 112px;
        text-align: center;
      }

      .text1 {
        margin-top: 8px;
        font-size: 24px;
        color: #1d2754;
        line-height: 50px;
        text-indent: 2em;
        text-align: justify;
      }

      .text2 {
        margin-top: 50px;
        font-size: 24px;
        color: #1d2754;
        line-height: 50px;
        text-indent: 2em;
        text-align: justify;
      }

      .text3 {
        margin: 50px 0;
        font-size: 24px;
        color: #1d2754;
        line-height: 50px;
        text-indent: 2em;
        text-align: justify;
      }
    }
  }

  .ontrial {
    width: 100%;
    height: 309px;
    background-image: url("https://img.yilieyun.com/oss/ylyofficialWebImagse/bg_blue_01@2x.jpg");
    background-repeat: no-repeat;
    background-size: 105%;
    padding-top: 62px;

    h3 {
      font-size: 50px;
      color: #ffffff;
      line-height: 70px;
      text-align: center;
    }

    p {
      width: 158px;
      height: 66px;
      background: #ffffff;
      font-size: 24px;
      color: #0084ff;
      line-height: 66px;
      text-align: center;
      border-radius: 7px;
      margin: 0 auto;
      margin-top: 53px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/about/media.vue